import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  alertApiRef,
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  ErrorApi,
  errorApiRef,
  oauthRequestApiRef,
} from '@backstage/core-plugin-api';
import {
  ErrorAlerter,
  ErrorApiForwarder,
  OAuth2,
} from '@backstage/core-app-api';
import { hkidOAuthApiRef } from './auth-providers/hkid';
import { initSentry, wrapErrorApi } from './sentry';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),

  ScmAuth.createDefaultApiFactory(),

  createApiFactory({
    api: hkidOAuthApiRef,
    deps: {
      discoveryApi: discoveryApiRef,
      oauthRequestApi: oauthRequestApiRef,
      configApi: configApiRef,
    },
    factory: ({ discoveryApi, oauthRequestApi, configApi }) => {
      return OAuth2.create({
        configApi,
        discoveryApi,
        oauthRequestApi,
        environment: configApi.getOptionalString('auth.environment'),
      });
    },
  }),

  createApiFactory({
    api: errorApiRef,
    deps: { alertApi: alertApiRef, configApi: configApiRef },
    factory: ({ alertApi, configApi }): ErrorApi => {
      initSentry(configApi);
      return wrapErrorApi(new ErrorAlerter(alertApi, new ErrorApiForwarder()));
    },
  }),
];
